import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import * as uuid from "uuid";
import { Context } from "../../../../store/store";
import { StoreContextType } from "@/store/types";
import { TEST_LOAD_SUCCESS } from "../../../../store/actions";
import { API_URLS } from "../../../../utils/api-constants";
import { axiosGet } from "../../../../utils/queries";
import { isObjectId } from "../../../../utils/regex";
import { buildUrlWithGetParams } from "../utils";

interface UsePublicTestParams {
  testId: string;
  sessionId?: string;
  autoFetch?: boolean;
}

export function usePublicTest({ testId, sessionId }: UsePublicTestParams) {
  const history = useHistory();
  const [state, dispatch] = useContext<StoreContextType>(Context as any);
  const { publicTest } = state;
  const [isLoading, setIsLoading] = useState(true);
  const [isRefetching, setIsRefetching] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchTest = async (isRefetch: boolean = false) => {
    if (!testId || !isObjectId(testId)) {
      history.push("/");
      return;
    }

    setIsLoading(true);
    setError(null);

    if (isRefetch) {
      setIsRefetching(true);
    }

    try {
      let url = `${API_URLS.PUBLIC_TEST}/${testId}`;

      if (sessionId && uuid.validate(sessionId)) {
        url = `${API_URLS.PUBLIC_TEST}/${testId}/${sessionId}`;
      }

      const payload = await axiosGet(buildUrlWithGetParams(url));
      dispatch({ type: TEST_LOAD_SUCCESS, payload });
    } catch (err) {
      setError(err as Error);
      history.push("/");
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  useEffect(() => {
    fetchTest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    publicTest,
    isLoading,
    isRefetching,
    error,
    refetch: () => fetchTest(true),
  };
}
